<template>
  <div class="header-page">
    <page-header v-bind="headerProps" :style="headerStyle"/>
    <div class="header-page-content" :class="{ sticky: stickyHeader }" ref="content">
      <slot />
    </div>
  </div>
</template>

<script>
import PageHeader, { PageHeaderProps } from './PageHeader.vue';

export default {
  name: 'HeaderPage',
  components: { PageHeader },
  props: {
    headerProps: PageHeaderProps,
    stickyHeader: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    headerStyle() {
      return this.stickyHeader ? {
        position: 'sticky',
        top: 0,
      } : undefined;
    },
  },
  methods: {
    resetScroll() {
      if (this.$refs.content) {
        this.$refs.content.scrollTop = 0;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  .header-page-content {
    flex: 1;
    &.sticky {
      overflow-y: auto;
    }
  }
}
</style>
